module.exports = __webpack_public_path__ + "static/media/ulip.97212975.mp3";